// extracted by mini-css-extract-plugin
export default {"menuButton":"MenuButton_menuButton__8VUcJ","menuButton_text":"MenuButton_menuButton_text__pG+4X"};